<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-section">
        <div class="footer-logo">武汉天冉网络科技有限公司</div>
        <div class="footer-desc">专注于为动漫爱好者提供高质量的番剧内容</div>
      </div>
      <div class="footer-section">
        <div class="footer-title">联系我们</div>
        <div class="footer-info">
          <div class="footer-item"><i class="icon address"></i>地址：湖北省武汉市洪山区雄楚大街452号保利蓝海郡G6栋1单元20层3室-2</div>
          <div class="footer-item"><i class="icon phone"></i>电话：13641239621</div>
          <div class="footer-item"><i class="icon email"></i>邮箱：wudongjian@huashi.tv</div>
        </div>
      </div>
      <div class="footer-section">
        <div class="footer-title">帮助中心</div>
        <div class="footer-links">
          <router-link to="/privacy" class="footer-link">隐私协议</router-link>
          <router-link to="/statement" class="footer-link">网站声明</router-link>
          <router-link to="/self-review" class="footer-link">自审制度</router-link>
          <router-link to="/youth-protection" class="footer-link">青少年保护</router-link>
          <router-link to="/agreement" class="footer-link">用户协议</router-link>
          <router-link to="/feedback" class="footer-link">问题投稿</router-link>
        </div>
      </div>
    
    </div>
    <div class="footer-bottom">
      <div class="copyright">© 2026 武汉天冉网络科技有限公司 版权所有</div>
      <div class="icp">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp-link">鄂ICP备2023004985号-5</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter'
};
</script>

<style scoped>
.footer {
  background-color: #1f2937;
  color: #9ca3af;
  padding: 40px 0 20px;
  width: 100%;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.footer-section {
  flex: 1;
  margin-right: 30px;
}

.footer-section:last-child {
  margin-right: 0;
}

.footer-logo {
  font-size: 24px;
  font-weight: bold;
  color: #ff6b81;
  margin-bottom: 15px;
}

.footer-desc {
  font-size: 14px;
  line-height: 1.5;
}

.footer-title {
  font-size: 18px;
  font-weight: bold;
  color: white;
  margin-bottom: 15px;
}

.footer-info {
  font-size: 14px;
}

.footer-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.footer-item .icon {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  background-color: #9ca3af;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link {
  color: #9ca3af;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
  display: inline-block;
}

.footer-link:hover {
  color: #ff6b81;
}

.footer-social {
  display: flex;
}

.social-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #374151;
  margin-right: 10px;
  display: inline-block;
}

.footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  border-top: 1px solid #374151;
  margin-top: 30px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}

.icp-link {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-link:hover {
  color: #ff6b81;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
  }
  
  .footer-section {
    margin-right: 0;
    margin-bottom: 30px;
  }
  
  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }
  
  .copyright {
    margin-bottom: 10px;
  }
}
</style> 